import type { SVGAttributes } from 'react';

export function NotFoundIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="152" height="152" viewBox="0 0 152 152" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<circle opacity="0.03" cx="76" cy="76" r="76" fill="currentColor" />
			<circle opacity="0.05" cx="76" cy="76" r="60" fill="currentColor" />
			<path
				d="M106 91.6002C106 99.5502 99.5502 106 91.6002 106C87.3402 106 83.5301 104.14 80.8901 101.2C78.6101 98.6502 77.2002 95.2902 77.2002 91.6002C77.2002 83.6502 83.6502 77.2002 91.6002 77.2002C95.7102 77.2002 99.4301 78.94 102.07 81.73C102.04 81.73 102.04 81.7301 102.07 81.7601C104.5 84.3401 106 87.7902 106 91.6002Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.44 95.6199L87.8501 88"
				stroke="currentColor"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.3501 88.0903L87.76 95.7103"
				stroke="currentColor"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M106 66.0699C106 71.9799 104.47 77.1998 102.07 81.7298C99.43 78.9398 95.71 77.2 91.6 77.2C83.65 77.2 77.2001 83.6499 77.2001 91.5999C77.2001 95.2899 78.61 98.65 80.89 101.2C79.78 101.71 78.76 102.13 77.86 102.43C76.84 102.79 75.16 102.79 74.14 102.43C65.44 99.4599 46 87.0699 46 66.0699C46 56.7999 53.47 49.2998 62.68 49.2998C68.11 49.2998 72.97 51.9399 76 55.9899C79.03 51.9399 83.89 49.2998 89.32 49.2998C98.53 49.2998 106 56.7999 106 66.0699Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
